import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";
import type EcommerceSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceSignalFilters";
import EcommerceSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceSignalSubType";
import EcommerceSignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/ecommerce/EcommerceSignalTemplate";
import SignalTemplatesManager from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplatesManager";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import { UNKNOWN_ALIAS, UNKNOWN_SIGNAL_TRANSLATABLE } from "../../../constants/common";

import { EcommerceTemplateAlias } from "./types";

export default class EcommerceSignalTemplatesManager extends SignalTemplatesManager<EcommerceSignalFilters> {
    getEmptyTemplate(): Readonly<EcommerceSignalTemplate> {
        return new EcommerceSignalTemplate({
            alias: UNKNOWN_ALIAS,
            name: UNKNOWN_SIGNAL_TRANSLATABLE,
            signalSource: SignalSource.Platform,
            description: UNKNOWN_SIGNAL_TRANSLATABLE,
            filters: {},
        });
    }

    getDefaultTemplate(): Readonly<EcommerceSignalTemplate> {
        return this.getEmptyTemplate();
    }

    getTemplates(): readonly EcommerceSignalTemplate[] {
        return [
            new EcommerceSignalTemplate({
                alias: EcommerceTemplateAlias.OnlineRevenueChange,
                name: {
                    key: signalsI18nKeys.ecommerce.templates.onlineRevenueChange.name,
                },
                description: {
                    key: signalsI18nKeys.ecommerce.templates.onlineRevenueChange.description,
                },
                signalSource: SignalSource.Platform,
                filters: {
                    change: {
                        metric: "OnlineRevenue",
                        direction: undefined,
                        period: undefined,
                    },
                },
                signalSubType: EcommerceSignalSubType.OnlineRevenueChange,
                templateGroup: 1,
                signalLifecycleState: "post-beta",
            }),
            new EcommerceSignalTemplate({
                alias: EcommerceTemplateAlias.OnlineRevenueReached,
                name: {
                    key: signalsI18nKeys.ecommerce.templates.onlineRevenueReached.name,
                },
                description: {
                    key: signalsI18nKeys.ecommerce.templates.onlineRevenueReached.description,
                },
                signalSource: SignalSource.Platform,
                filters: {
                    bucketTransition: {
                        metric: "OnlineRevenue",
                        bucket: undefined,
                    },
                },
                signalSubType: EcommerceSignalSubType.OnlineRevenueReached,
                templateGroup: 1,
                signalLifecycleState: "post-beta",
            }),
            new EcommerceSignalTemplate({
                alias: EcommerceTemplateAlias.OnlineTransactionsChange,
                name: {
                    key: signalsI18nKeys.ecommerce.templates.onlineTransactionsChange.name,
                },
                description: {
                    key: signalsI18nKeys.ecommerce.templates.onlineTransactionsChange.description,
                },
                signalSource: SignalSource.Platform,
                filters: {
                    change: {
                        metric: "TransactionVolume",
                        direction: undefined,
                        period: undefined,
                    },
                },
                signalSubType: EcommerceSignalSubType.OnlineTransactionsChange,
                templateGroup: 1,
                signalLifecycleState: "post-beta",
            }),
            new EcommerceSignalTemplate({
                alias: EcommerceTemplateAlias.OnlineTransactionsReached,
                name: {
                    key: signalsI18nKeys.ecommerce.templates.onlineTransactionsReached.name,
                },
                description: {
                    key: signalsI18nKeys.ecommerce.templates.onlineTransactionsReached.description,
                },
                signalSource: SignalSource.Platform,
                filters: {
                    bucketTransition: {
                        metric: "TransactionVolume",
                        bucket: undefined,
                    },
                },
                signalSubType: EcommerceSignalSubType.OnlineTransactionsReached,
                templateGroup: 1,
                signalLifecycleState: "post-beta",
            }),
        ];
    }
}
